import { render, staticRenderFns } from "./optigop.view.vue?vue&type=template&id=3a32ae1a&scoped=true&"
import script from "./optigop.view.vue?vue&type=script&lang=ts&"
export * from "./optigop.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a32ae1a",
  null
  
)

export default component.exports